module.exports = __webpack_public_path__ + "static/img/img9.0673508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img9.png
// module id = aNTU
// module chunks = 36